import React from 'react';
import { integrations } from '../mock';

const LogoBadge = ({ short, name }) => (
  <div className="flex items-center gap-3 opacity-80 hover:opacity-100 transition-opacity">
    <div className="w-10 h-10 rounded-md bg-white/[0.04] border border-white/10 grid place-items-center text-[12px] mono text-white/70">
      {short}
    </div>
    <span className="text-white/75 text-[14px] tracking-tight">{name}</span>
  </div>
);

export default function Operations() {
  return (
    <section id="operations" className="section text-white">
      <div className="mx-auto max-w-[1400px] px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <p className="eyebrow mb-6">Operations</p>
            <h2 className="h-display text-[54px] md:text-[68px] leading-[1.02] text-white max-w-[620px]">
              Forecasting, stock, labor, supply, and more, all handled for you.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-10 space-y-6">
            <p className="text-white/60 text-[15px] leading-[1.7] max-w-[520px]">
              Grocera connects to everything you already run: your POS, your inbox, your invoices,
              your books. Grocera replaces none of it.
            </p>
            <p className="text-white/60 text-[15px] leading-[1.7] max-w-[520px]">
              Then Grocera runs your week: demand, ordering, labor, supply chain, every store. You
              approve from your phone, or let Grocera do it for you.
            </p>
          </div>
        </div>

        <div className="mt-20 flex flex-wrap items-center gap-x-14 gap-y-6">
          {integrations.map((i) => (
            <LogoBadge key={i.name} short={i.short} name={i.name} />
          ))}
          <span className="text-white/50 text-[13px]">Plus any system you run</span>
        </div>
      </div>
    </section>
  );
}
